import { Button, Dialog, FormControl, Select, TextField, Divider, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { ApiRequest } from "GlobalFunctions";
import ImageUploader from "elements/ImageUploader";

export default function BrandEditor(props: any) {
  const { openEditor, setOpenEditor, banner_id, loadList } = props;
  const { enqueueSnackbar } = useSnackbar();

  const defaultValues = {
    banner_id: banner_id ? banner_id : "null",
    section: "",
    image: '',
    url: '',
    title: '',
    subtitle: '',
    button_text: '',
  };

  const [formValues, setFormValues] = useState(defaultValues);
  const [files, setFiles] = useState<any>([]);

  useEffect(() => {
    if (openEditor) {
      setFormValues({ ...defaultValues, banner_id: banner_id ? banner_id : "null" });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openEditor]);

  const [loadingButton, setLoadingButton] = useState(false);

  const submit = async () => {
    if (!formValues.section) {
      enqueueSnackbar("Sección es requerida", { variant: 'error' });
      return;
    }
    if (!formValues.image) {
      enqueueSnackbar("Imagen es requerida", { variant: 'error' });
      return;
    }

    const body = new FormData();
    body.append('formValues', JSON.stringify(formValues));
    if (files) body.append("image", files);

    setLoadingButton(true);
    await ApiRequest({
      url: '/banners/addedit',
      method: 'POST',
      formData: true,
      body: body,
      setResponse: (response: any) => {
        setLoadingButton(false);
        setOpenEditor(false);
        loadList();
        enqueueSnackbar(response.message, { variant: 'success' });
        setFormValues(defaultValues);
      }
    });
  };

  const field = (key: keyof typeof formValues, label: string, placeholder?: string) => (
    <TextField
      label={label}
      fullWidth
      value={formValues[key]}
      onChange={(e) => setFormValues({ ...formValues, [key]: e.target.value })}
      placeholder={placeholder}
      variant="outlined"
    />
  );

  return (
    <Dialog open={openEditor} onClose={() => setOpenEditor(false)} maxWidth="sm" fullWidth>
      <div className="DialogContainer">
        <div className="ModuleWrapper">
          <div className="boxContainerHeader">
            <div className="boxContainerTitle">
              <h2 className="h2_title">Banner</h2>
              <span className="h2_subtitle">Editar</span>
            </div>
          </div>

          <div className="input_group">

            <ImageUploader
              className="banner_image_uploader"
              image={formValues.image}
              setImage={(newImage) => setFormValues({ ...formValues, image: newImage })}
              setFiles={setFiles}
            />

            <Typography variant="caption" color="text.secondary" sx={{ mt: -1, display: 'block', lineHeight: 1.6 }}>
              <strong>Dimensiones recomendadas:</strong><br />
              • Slider (home / enfermeras): <strong>1920 × 400 px</strong> — panorámico horizontal<br />
              • Popup emergente horizontal: <strong>680 × 400 px</strong><br />
              • Popup emergente vertical: <strong>400 × 600 px</strong>
            </Typography>

            <FormControl fullWidth>
              <Select
                native
                value={formValues.section}
                onChange={(e) => setFormValues({ ...formValues, section: e.target.value })}
                inputProps={{ name: "section" }}
              >
                <option value="">— Seleccionar tipo y ubicación —</option>
                <optgroup label="Popup emergente">
                  <option value="global">Popup — Global (todas las páginas)</option>
                  <option value="home">Popup — Home</option>
                  <option value="blog">Popup — Blog</option>
                  <option value="chat">Popup — Chat</option>
                </optgroup>
                <optgroup label="Slider publicitario (rota cada 10 seg)">
                  <option value="slider-home">Slider — Home</option>
                  <option value="slider-enfermeras">Slider — Lista de enfermeras</option>
                </optgroup>
              </Select>
            </FormControl>

            {field('url', 'URL de destino (opcional)', 'https://especialistaenheridas.cl/enfermeras')}

            <Divider sx={{ my: 1 }}>
              <Typography variant="caption" color="text.secondary">Texto sobre el banner (opcional)</Typography>
            </Divider>

            {field('title', 'Título', 'Ej: Encuentra tu enfermera en Puerto Montt')}
            {field('subtitle', 'Subtítulo', 'Ej: Especialistas en curación de heridas a domicilio')}
            {field('button_text', 'Texto del botón', 'Ej: Ver enfermeras disponibles')}

            <Typography variant="caption" color="text.secondary" sx={{ mt: -1 }}>
              Si completas estos campos, el texto aparecerá sobre la imagen del banner con un botón blanco.
            </Typography>

          </div>

          <div className="dialogButtons">
            <Button onClick={() => setOpenEditor(false)} variant="outlined">Cancelar</Button>
            <Button onClick={submit} variant="contained" disabled={loadingButton}>
              {loadingButton ? 'Guardando...' : 'Guardar'}
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
